import dayjs from "dayjs";
import React, { useState } from "react";
import { Grid } from "@mui/material";
import FilterSet from "../../../components/selectors/Filterset";
import { GamesDataApi, GamesData, League } from "../../../farsight-api";
import {targets} from "../../../Context";
import TableDisplayGrid, { rowStyle } from "../../../components/datagrids/shared/TableDisplayGrid";
import { ColumnTypes } from "../../../components/datagrids/styled_datagrid";
import { useReferentialContext } from "../../../Context";
import WindowContainer from "../../../components/layout/WindowContainer";

export default function LeagueMatchHistory() {
    const [from, setFrom] = useState(dayjs().subtract(3, "month"));
    const [until, setUntil] = useState(dayjs());
    const [leagues, setLeagues] = useState([] as League[]);

    const [paramObject, setParamObject] = useState({
        ordering: "-date",
    } as any);
    console.log(paramObject);
    const api = useReferentialContext().farsightApi.gamesData;

    return (
        <WindowContainer direction={"column"} spacing={2}>
            <FilterSet paramObject={paramObject} setParamObject={setParamObject} target={targets.competitive} leagues={leagues} setLeagues={setLeagues} date__gte={from} setDateGte={setFrom} date__lt={until} setDateLt={setUntil} />
            <TableDisplayGrid
                display_all={false}
                request={() => api.list(paramObject)}
                rowStyle={rowStyle.outcome}
                sortBy={"date"}
                paramObject={paramObject}
                custom_columns={[ColumnTypes.boolean((row: GamesData) => row.drafting_sim_predicted_winner === row.winner, "Pred Res", "matchid")]}
                disp_columns={["league", "date", "team1", "team2", "patch", "duration", "winner", "team1champions", "team2champions", "game_id", "vodGameStart", "drafting_sim_team1_pred", "drafting_sim_team2_pred"]}
            />
        </WindowContainer>
    );
}
